import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Text,
  SimpleGrid,
  Button,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { deletePost, getAllPosts } from "../redux/admin/admin.actions";

const PostList = () => {
  const { posts } = useSelector((store) => store.admin);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllPosts());
  }, []);

  const handleDelete = (id) => {
    dispatch(deletePost(id));
    dispatch(getAllPosts());
  };
  return (
    <SimpleGrid
      spacing={4}
      templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
    >
      {posts.length > 0 ? (
        posts?.map((el) => (
          <Card key={el._id}>
            <CardHeader>
              <Heading size="sm">{el.end?.split("T")[0]} </Heading>
            </CardHeader>
            <CardBody>
              <Text>{el.title}</Text>
            </CardBody>
            <CardFooter>
              <Button colorScheme={"red"} onClick={() => handleDelete(el._id)}>
                Delete
              </Button>
            </CardFooter>
          </Card>
        ))
      ) : (
        <Heading w="800px" textAlign={"center"} mt={100}>
          No Posts are available to display
        </Heading>
      )}
    </SimpleGrid>
  );
};

export default PostList;
